import React, { ReactNode } from 'react';
import { useAuth } from './AuthProvider';
import LoginPage from './LoginPage';
import { debugLog } from '../../utils/debugLogger';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  debugLog('[ProtectedRoute] render - isLoading:', isLoading, 'isAuthenticated:', isAuthenticated);

  // Show loading spinner while checking authentication
  if (isLoading) {
    debugLog('[ProtectedRoute] Showing loading spinner');
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #ffffff40',
          borderTop: '4px solid #ffffff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}></div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // If not authenticated, show login page
  if (!isAuthenticated) {
    debugLog('[ProtectedRoute] User not authenticated, showing LoginPage');
    return <LoginPage />;
  }

  // If authenticated, show protected content
  debugLog('[ProtectedRoute] User authenticated, showing protected content');
  return <>{children}</>;
};

export default ProtectedRoute;
